<template>
    <el-dialog
            :before-close="handleDialogClose"
            :close-on-click-modal="false"
            :visible.sync="editMemberDialogVisible"
            class="custom_form_dialog custom-form-dialog personnel_form_dialog"
            title=""
            width="560px">
        <template #title>
            <div class="avatar_name_wrap">
                <img :src="userDetails.header_img ||'https://download.hecoos.com/enlightv/2024-42/1a3b607fe54205013ac90744ec5405bd.jpg'"
                     alt=""
                     class="header_img"/>
                <div>
                    <p class="user_name" v-text="userDetails.name"></p>
                    <p><span v-text="userDetails.did_name"></span></p>
                </div>
            </div>
        </template>
        <div class="custom_form_body">
            <CustomFormPc
                    v-if="dataLoaded"
                    ref="customFormPc"
                    :field_form="'users'"
                    :field_list="formInfoList"
                    :form_detail="formData"
                    :is_form_module="true"
                    :pk_id="user_id"
                    @submit-form="summitFormData"/>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm">保存</el-button>
        </span>
    </el-dialog>
</template>
<script>
    import {editUser, getFormFields, getUserDetail, GetUserProfileEdits, UpdateProfileEdit} from "@/api";
    import CustomFormPc from "@/components/pComponents/CustomFormPc";

    export default {
        name: "editMember",
        data() {
            return {
                formData: {},
                userDetails: {
                    header_img: "",
                    name: "",
                    did_name: "",
                    user_id: 0,
                },
                formInfoList: [],
                dataLoaded: false,
                edit_id: "", // 完善信息之后保存的时候传的参数
            };
        },
        components: {CustomFormPc},
        created() {
            this._getFromFields();
        },
        props: {
            editMemberDialogVisible: {
                type: Boolean,
                default: false,
            },
            user_id: {
                type: Number,
                default: 0,
            },
            profile_edit: {
                type: Boolean,
                default: false,
            }, // 是否是邀请之后需要编辑的
        },
        methods: {
            _getFromFields() {
                this.loading = true;
                getFormFields({
                    field_form: "users",
                })
                        .then((res) => {
                            if (res.code === 200) {
                                let formInfoList = res.data;
                                if(this.profile_edit) {
                                    // 信息完善的时候不可以编辑姓名
                                    formInfoList.forEach(item=> {
                                        if(item._child) {
                                            item._child.forEach(child=> {
                                                if(child.field_key == 'name') {
                                                    this.$set(child, 'field_disabled', true)
                                                }
                                            })
                                        }
                                    })
                                }
                                this.formInfoList = formInfoList;
                                if (this.user_id) {
                                    if (this.profile_edit) {
                                        // 被邀请之后 编辑过的
                                        GetUserProfileEdits({
                                            user_id: this.user_id,
                                        }).then((res) => {
                                            if (res.code === 200) {
                                                // edit_id编辑的时候用
                                                this.edit_id = res.data.id;
                                                // 如果编辑过 就用最新编辑的数据，否则使用最开始的数据
                                                let data = res.data.edited_data ? res.data.edited_data : res.data.original_data;
                                                this.formData = data;
                                                this.userDetails.header_img = data.avatar;
                                                this.userDetails.name = data.name.value;
                                                this.userDetails.did_name =
                                                        data.department_id.text && data.department_id.text.length
                                                                ? data.department_id.text[0].full_path
                                                                : "";
                                                this.dataLoaded = true;
                                            } else {
                                                this.$message.error(res.message);
                                            }
                                        });
                                    } else {
                                        getUserDetail({
                                            user_id: this.user_id,
                                        }).then((res) => {
                                            if (res.code === 200) {
                                                this.formData = res.data;
                                                this.userDetails.header_img = res.data.avatar;
                                                this.userDetails.name = res.data.name.value;
                                                this.userDetails.did_name =
                                                        res.data.department_id.text && res.data.department_id.text.length
                                                                ? res.data.department_id.text[0].department_name
                                                                : "";
                                                this.dataLoaded = true;
                                            } else {
                                                this.$message.error(res.message);
                                            }
                                        });
                                    }
                                }
                            } else {
                                this.$message.error(res.message);
                            }
                            this.loading = false;
                        })
                        .catch(() => {
                            this.loading = false;
                        });
            },

            handleDialogClose() {
                this.$emit("update:editMemberDialogVisible", false);
            },

            handleDialogConfirm() {
                this.$refs.customFormPc.handleClickPublish();
            },

            summitFormData(customForm) {
                if (this.profile_edit) {
                    // 被邀请之后 编辑过的
                    const data = {
                        edit_id: this.edit_id,
                        edited_data: customForm,
                    };
                    UpdateProfileEdit(data).then((res) => {
                        if (res.code === 200) {
                            this.$message.success("编辑成功");
                            this.$emit("success-callback");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else {
                    const data = {
                        ...customForm,
                        user_id: this.user_id,
                    };
                    editUser(data).then((res) => {
                        if (res.code === 200) {
                            this.$emit("update:editMemberDialogVisible", false);
                            this.$message.success("编辑成功");
                            this.$emit("success-callback");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                }
            },
        },
    };
</script>
